module.exports = __webpack_public_path__ + "static/media/destination_rusia.048c7c9e.jpg";